import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GladlyHelpCenterComponent } from './gladly-help-center/gladly-help-center.component';

@NgModule({
  exports: [GladlyHelpCenterComponent],
  imports: [CommonModule, GladlyHelpCenterComponent],
})
export class GladlyHelpCenterModule {}
